module.exports = __webpack_public_path__ + "img/undead_5.83a3cef8.png";